<mat-card class="page">
  <mat-card-header>
    <store-header-container
      [iconUrl]="product.iconUrl"
      [title]="product.name"
      [tagline]="product.tagline"
      [chipLabels]="product.getLmiCategoryNames()"
      [appPrice]="appPrice"
      [partnerCurrency]="partnerCurrency"
      [primaryPricingActionLabel]="primaryPricingActionLabel"
      [pricingActionLabel]="pricingActionLabel"
      [pricingActionEnabled]="showPricingAction"
      [actionLabel]="getActionLabel()"
      [actionEnabled]="product.isArchived"
      [showAction]="showActionButton"
      [showPricing]="showPricing"
      [hasVerifiedContract]="hasVerifiedContract"
      [loaded]="loaded"
      (primaryPricingActionSelected)="primaryPricingActionSelected.emit()"
      (pricingActionSelected)="pricingActionSelected.emit()"
      (actionSelected)="enableClicked.emit()"
    ></store-header-container>
  </mat-card-header>
  <mat-card-content class="product-details product-content">
    <div class="left-column">
      <ng-container *ngIf="product.description || product.keySellingPoints">
        <store-selling-info
          [description]="product.description"
          [keySellingPoints]="product.keySellingPoints"
        ></store-selling-info>
      </ng-container>
      <section *ngIf="product.addons?.length > 0">
        <h2>Add-Ons</h2>
        <store-va-addon-list
          (addonSelected)="onAddonSelected($event)"
          [addons]="getAddons()"
          [showPricing]="showPricing"
          [hasVerifiedContract]="hasVerifiedContract"
          [canAccessContractPricing]="canAccessContractPricing"
          [partnerID]="partnerID"
        ></store-va-addon-list>
      </section>

      <section *ngIf="product.faqs?.length > 0">
        <h2>FAQs</h2>
        <store-faqs [faqs]="product.faqs"></store-faqs>
      </section>
    </div>

    <div class="right-column">
      <section *ngIf="product.restrictions?.country?.whitelist?.length > 0">
        <store-supported-countries [countryCodes]="product.restrictions.country.whitelist"></store-supported-countries>
      </section>

      <section *ngIf="product.screenshotUrls?.length > 0">
        <h2>Gallery</h2>
        <va-image-gallery [imageUrls]="product.screenshotUrls"></va-image-gallery>
      </section>

      <section *ngIf="product.files?.length > 0">
        <h2>Files</h2>
        <store-files [files]="product.files"></store-files>
      </section>
    </div>
  </mat-card-content>
</mat-card>
